import { createFileRoute } from '@tanstack/react-router';
import { PatientPage } from '@/features/clinical/pages/patient-page';

export const Route = createFileRoute('/_app/clinical/patients/$customerId')({
  component: function PatientRoute() {
    const { customerId } = Route.useParams();
    return <PatientPage customerId={customerId} />;
  },
});
